<group-corrections
  open-rule-violations-screen="vm.openRuleViolationsScreen"
  current-state-url="vm.$state.current.url"
/>
